// Stable element ids shared by every OLAP V2 page, so a guided tour authored for one
// dataset can be reused on any other OLAP page. Each id is set on a real anchor element in
// the shared OLAP components (filters bar, config panel, chart, grid) and on the header
// business-profile select. el-tour resolves these directly from the `#id` selector string.
//
// Only one OLAP page is mounted at a time, so these ids stay unique at runtime even though
// the components that carry them are shared across all datasets.
export const OLAP_TOUR_TARGETS = {
  bpSelect: '#olap-bp-select',
  marketplace: '#olap-marketplace',
  datePicker: '#olap-datepicker',
  configs: '#olap-configs',
  chart: '#olap-chart',
  subrange: '#olap-subrange',
  grid: '#olap-grid',
  // The header strip at the grid's top. Used as the grid-step anchor on chart-less pages where
  // the grid fills the viewport top-to-bottom (e.g. finance/cogs): there el-tour has no room to
  // place the popover outside the full grid and it clips (el-tour's floating-ui middleware only
  // clamps horizontal overflow, never vertical). The header always leaves room below.
  gridHeader: '#olap-grid .ag-header',
  // The sidebar is rendered internally by AG Grid, so it has no id of its own — scope it to
  // the grid's id instead.
  sidebar: '#olap-grid .ag-side-bar',
  // Chart-block tour anchors (WP-975), all inside MetricsByDatePanel. The per-card selectors
  // resolve to the FIRST metric card — enough for the tour to point at one real example of
  // the per-card controls.
  chartHeader: '#olap-chart .panel-header',
  chartMetrics: '#olap-chart-metrics',
  chartMetricCard: '#olap-chart-metrics .chart-metric',
  chartMetricMa: '#olap-chart-metrics .chart-metric-ma-list',
  chartCanvas: '#olap-chart .chart-wrapper',
  chartSegmentation: '#olap-chart-segmentation',
  chartProductChanges: '#olap-chart-product-changes',
  // Grid deep-dive tour anchors (WP-984), all inside OlapGrid. The grouping bar and
  // status bar are AG-Grid chrome; the sidebar tool-panel content only exists in the DOM
  // while its panel is open, so the grid tour opens/activates each panel via a per-step
  // `panel` hint that OlapTour applies (gridApi.openToolPanel) before spotlighting.
  gridGroupingBar: '#olap-grid .ag-column-drop-horizontal',
  // The currently-open sidebar tool panel (only one is un-hidden at a time). Steps 3–5
  // (Dimensions / Metrics / Filters) all resolve here — each step opens its own panel
  // first, so this points at whichever panel is active for that step.
  gridOpenToolPanel: '#olap-grid .ag-side-bar .ag-tool-panel-wrapper:not(.ag-hidden)',
  // The custom "Sorting & Display" panel and its Display toggle list — both unique
  // classes inside that one panel (SortStatusToolPanel.vue).
  gridSortPanel: '#olap-grid .sort-status-tool-panel',
  gridDisplayToggles: '#olap-grid .display-toggle-list',
  gridStatusBar: '#olap-grid .ag-status-bar',
};
